import ReactGA from 'react-ga4';
import { API } from 'aws-amplify';
import { graphqlOperation, GraphQLResult } from '@aws-amplify/api-graphql';
import { v4 as uuidv4 } from 'uuid';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { Logger, LogType } from '@hitiq/logger';
import { userCreateQuery } from './userCreate.query';
import { User, CreateUserInput } from './users.interfaces';

export const createUserThunk = createAsyncThunk(
  'user/createUser',
  async (
    payload: {
      loggingService: Logger;
      resource: CreateUserInput;
    },
    thunkApi,
    // TODO: figure out return type of rejectWithValue something like RejectWithValue<Alert>
  ): Promise<boolean | any> => {
    const { loggingService, resource } = payload;

    try {
      const result = (await API.graphql(
        graphqlOperation(userCreateQuery, { input: resource }),
      )) as GraphQLResult<{ createUser: User }>;
      return translateResult(result, thunkApi);
    } catch (error: any) {
      return thunkApi.rejectWithValue(
        error?.errors.map((err: any) => {
          return {
            id: uuidv4(),
            ...err,
          };
        }),
      );
    }
  },
);

function translateResult(
  result: GraphQLResult<{ createUser: User }>,
  thunkApi: any,
) {
  // QUESTION: do we need this check? Is it possible it succeeds but fail to return user?
  if (!result?.data) {
    return thunkApi.rejectWithValue({
      id: uuidv4(),
      message: 'createUser failed to return user',
    });
  }
  const appUser = result.data.createUser;
  ReactGA.event({
    category: 'User',
    action: 'Create',
  });
  return appUser;
}
